/**
 * Check if today is Saturday.
 * @returns {boolean} Return true, if today is Saturday, else false.
 */
function isTodaySaturday() {
  const today = new Date();
  return today.getDay() === 6;
}


export default isTodaySaturday